
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.974 2.898c-.037.228-.011.711.383.82.394.11 1.222.247 1.586.301v.383h-.136l-.548-.191-1.094.492c-.273-.009-1.094.077-2.188.493-1.094.415-3.355-.028-4.35-.301-1.285.036-4.02.05-4.677-.192-.415.394.028.584.301.63l-1.094.492c-.118.045-.284.191 0 .41.177.136.921.661 1.66 1.179a3.747 3.747 0 015.602 3.964h5.836a3.747 3.747 0 015.42-4.066v-.174l-.593-1.507-2.634-1.229h-.725l-.096-.383c.082.046.266.133.343.114.095-.024-.114-.995-.343-1.235a4.609 4.609 0 00-.538-.466c-.115.155-.383.466-.535.466-.081 0-.182-.107-.298-.23-.158-.169-.345-.367-.547-.367-.282 0-.538.04-.63.06-.227.128-.665.415-.608.537.057.122.36.05.503 0zM22 10.626a3.073 3.073 0 11-6.146 0 3.073 3.073 0 016.146 0zm-1.765 0a1.308 1.308 0 11-2.617 0 1.308 1.308 0 012.617 0zM5.747 13.7a3.073 3.073 0 100-6.146 3.073 3.073 0 000 6.146zm0-1.764a1.308 1.308 0 100-2.617 1.308 1.308 0 000 2.617z","fill":"currentColor"}})])
          )
        }
      }
    